// extracted by mini-css-extract-plugin
export default {"ProviderSelection__Container":"ProviderSelection_ProviderSelection__Container__DO1db","ProviderSelection__TextContainer":"ProviderSelection_ProviderSelection__TextContainer__JtJD+"};